/*

MeganeTemplate

Version: 4.0.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

// UA情報
var UA = {};

function getUA() {

    const ua = navigator.userAgent.toLowerCase();
    const ver = navigator.appVersion.toLowerCase();

    // IE(11以外)
    UA.isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
    // IE6
    UA.isIE6 = UA.isMSIE && (ver.indexOf('msie 6.') > -1);
    // IE7
    UA.isIE7 = UA.isMSIE && (ver.indexOf('msie 7.') > -1);
    // IE8
    UA.isIE8 = UA.isMSIE && (ver.indexOf('msie 8.') > -1);
    // IE9
    UA.isIE9 = UA.isMSIE && (ver.indexOf('msie 9.') > -1);
    // IE10
    UA.isIE10 = UA.isMSIE && (ver.indexOf('msie 10.') > -1);
    // IE11
    UA.isIE11 = (ua.indexOf('trident/7') > -1);
    // IE
    UA.isIE = UA.isMSIE || UA.isIE11;
    // Edge
    UA.isEdge = (ua.indexOf('edge') > -1);

    // Google Chrome
    UA.isChrome = (ua.indexOf('chrome') > -1) && (ua.indexOf('edge') == -1);
    // Firefox
    UA.isFirefox = (ua.indexOf('firefox') > -1);
    // Safari
    UA.isSafari = (ua.indexOf('safari') > -1) && (ua.indexOf('chrome') == -1);
    // Opera
    UA.isOpera = (ua.indexOf('opera') > -1);

    // Windows
    UA.isWindows = (ua.indexOf('windows') > -1);

    // iPhone
    UA.isIphone = ua.indexOf('iphone') > 0;
    // iPad
    UA.isIpad = ua.indexOf('ipad') > 0 || (ua.indexOf('macintosh') > 0 && 'ontouchend' in document);
    // iPod
    UA.isIpod = ua.indexOf('ipod') > 0;
    // Android mobile
    UA.isAndroid = (ua.indexOf('android') > 0) && (ua.indexOf('mobile') > 0);
    // Android 
    UA.isAndroidMobileAndTab = (ua.indexOf('android') > 0);
    // dream
    UA.isDream = (ua.indexOf('dream') > 0);
    // CUPCAKE
    UA.isCupcake = (ua.indexOf('cupcake') > 0);
    // blackberry9500
    UA.isBlackberry9500 = (ua.indexOf('blackberry9500') > 0);
    // blackberry9530
    UA.isBlackberry9530 = (ua.indexOf('blackberry9530') > 0);
    // blackberry9520
    UA.isBlackberry9520 = (ua.indexOf('blackberry9520') > 0);
    // blackberry9550
    UA.isBlackberry9550 = (ua.indexOf('blackberry9550') > 0);
    // blackberry9800
    UA.isBlackberry9800 = (ua.indexOf('blackberry9800') > 0);
    // webOS
    UA.isWebOS = (ua.indexOf('webos') > 0);
    // incognito
    UA.isIncognito = (ua.indexOf('incognito') > 0);
    // webmate
    UA.isWebmate = (ua.indexOf('webmate') > 0);

    // Windows Phone
    UA.isWinPhone = ua.indexOf('windows phone') > 0;

    // Android Tablet (Android 4.x〜)
    UA.isAndroidTab = (ua.indexOf('android') > 0 && ua.indexOf('mobile') == -1);

    // Sp
    UA.isSp = UA.isIphone || UA.isIpod || UA.isAndroid || UA.isWinPhone;
    // Tab
    UA.isTab = UA.isIpad || UA.isAndroidTab;
    // Touch Device
    UA.isTouch = ('createTouch' in document) || ('ontouchstart' in document);
    // SmartDevice
    UA.isSmartDevice = UA.isIphone || UA.isIpad || UA.isIpod ||
        UA.isAndroidMobileAndTab || UA.isDream || UA.isCupcake || UA.isBlackberry9500 ||
        UA.isBlackberry9530 || UA.isBlackberry9520 || UA.isBlackberry9550 ||
        UA.isBlackberry9800 || UA.isWebOS || UA.isIncognito || UA.isWebmate;
}
$(function () {

    // UA情報を取得する
    getUA();
});